import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { withSagas } from 'decorators/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { FacebookConnectButton } from 'components/FacebookSDK/FacebookConnectButton';
import { FACEBOOK_FORM, facebookFormAction, initializeFacebookForm, watchFacebookFormSagas } from '../sagas/facebook.saga';
export var FacebookFormUnwrapped =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FacebookFormUnwrapped, _PureComponent);

  function FacebookFormUnwrapped() {
    _classCallCheck(this, FacebookFormUnwrapped);

    return _possibleConstructorReturn(this, _getPrototypeOf(FacebookFormUnwrapped).apply(this, arguments));
  }

  _createClass(FacebookFormUnwrapped, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onMount(this.props.hiddenFields);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          isDisabled = _this$props.isDisabled,
          hasSucceeded = _this$props.submitSucceeded,
          isSubmitting = _this$props.submitting;
      return React.createElement("form", {
        method: "post",
        onSubmit: handleSubmit,
        noValidate: true
      }, React.createElement(FacebookConnectButton, {
        className: classNames({
          'bt bt--lg bt--width-full bt--facebook': true,
          'bt--waiting': isSubmitting
        }),
        disabled: !!(hasSucceeded || isSubmitting || isDisabled)
      }, React.createElement(FormattedMessage, {
        id: "signup-card.lead.facebook-action",
        defaultMessage: "Sign up with Facebook"
      })));
    }
  }]);

  return FacebookFormUnwrapped;
}(PureComponent);
FacebookFormUnwrapped.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  hiddenFields: PropTypes.object,
  isDisabled: PropTypes.bool,
  onMount: PropTypes.func.isRequired,
  submitSucceeded: PropTypes.bool,
  submitting: PropTypes.bool
};
var formConfig = {
  enableReinitialize: true,
  form: FACEBOOK_FORM,
  keepDirtyOnReinitialize: true,
  onSubmit: facebookFormAction,
  onSubmitSuccess: function onSubmitSuccess(result, dispatch, props) {
    return props.onSuccess(result);
  }
};
export var FacebookForm = decorateWith(withSagas({
  watch: watchFacebookFormSagas
}), connect(null, {
  onMount: initializeFacebookForm
}), reduxForm(formConfig), withName('FacebookForm'))(FacebookFormUnwrapped);